import { render, staticRenderFns } from "./SensorGraph.component.vue?vue&type=template&id=7106a66f&scoped=true"
import script from "./SensorGraph.component.ts?vue&type=script&lang=js&external"
export * from "./SensorGraph.component.ts?vue&type=script&lang=js&external"
import style0 from "./SensorGraph.component.vue?vue&type=style&index=0&id=7106a66f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7106a66f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7106a66f')) {
      api.createRecord('7106a66f', component.options)
    } else {
      api.reload('7106a66f', component.options)
    }
    module.hot.accept("./SensorGraph.component.vue?vue&type=template&id=7106a66f&scoped=true", function () {
      api.rerender('7106a66f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/iot-simulator/SensorGraph.component.vue"
export default component.exports